<template>
  <Modal :title="title" v-on="$listeners">
    <template #content>
      <div v-if="!loading && !items.length" class="nodata">
        <slot name="nodata">該当するデータが見つかりませんでした。</slot>
      </div>
      <DynamicScroller
        v-else
        v-scroll-over="infinite ? next : null"
        class="items"
        :items="items"
        :minItemSize="minItemSize"
      >
        <template v-slot="{ item, index, active }">
          <DynamicScrollerItem :item="item" :active="active" :data-index="index" watchData emitResize>
            <div class="item" :class="{ 'is-disabled': isDisabled(item) }" @click="select(item)">
              <slot :item="item">
                {{ item.name }}
              </slot>
            </div>
          </DynamicScrollerItem>
        </template>
        <template v-if="loading" #after>
          <LoadingIndicator small />
        </template>
      </DynamicScroller>
    </template>
  </Modal>
</template>

<script>
import Modal from '@/components/molecules/Modal'
import LoadingIndicator from '@/components/molecules/LoadingIndicator'
import { DynamicScroller, DynamicScrollerItem } from '@/components/molecules/VirtualScroller'
import ScrollOver from '@/directives/ScrollOver'

/**
 * 選択モーダル
 */
export default {
  name: 'ItemSelectModal',
  components: {
    Modal,
    LoadingIndicator,
    DynamicScroller,
    DynamicScrollerItem,
  },
  directives: {
    ScrollOver,
  },
  props: {
    /** タイトル */
    title: { type: String, required: true },
    /** 選択肢 */
    items: { type: Array, required: true },
    minItemSize: { type: Number, default: 48 },
    loading: { type: Boolean, default: false },
    infinite: { type: Boolean, default: false },
    unselectableItemIds: { type: Array, required: false, default: () => [] },
  },
  methods: {
    select(item) {
      if (this.isDisabled(item)) return
      this.$emit('select', item)
      this.$emit('close')
    },
    isDisabled(item) {
      return this.unselectableItemIds.some(id => id === item.id)
    },
    next() {
      this.$emit('next')
    },
  },
}
</script>

<style lang="postcss" scoped>
.items {
  height: 100%;
}

.item {
  border-bottom: 1px solid var(--very-light-gray-3);
  cursor: pointer;
  line-height: 1.2;
  padding: 16px;

  &.is-disabled {
    background-color: var(--very-light-gray-4);
    pointer-events: none;
  }
}

.nodata {
  align-items: center;
  color: var(--dark-gray);
  display: flex;
  fill: var(--dark-gray);
  flex-direction: column;
  height: 100%;
  justify-content: center;
}
</style>
